<template>
	<!-- TODO condition to display if there's an available quest to accept, but no active quest... -->
	<!-- this state is currently not implemented ! -->
	<!-- then I would ideally solve it through type: none, which renders only what is in the slot without tutorial states and duplicity -->
	<TutorialStep
		v-if="tutorialActive && tutorialStep === 7"
		:type="TutorialStepTypes.ARROW"
		:relativeAlignment="'left'"
	>
		<template #default>
			<div class="quest-box-map icon-quests-56" @click="openQuestMap">
				<AppNotification
					v-if="showNotification"
					class="quest-box-map__notification"
					value="!"
					:type="StatusTypes.WARNING"
				/>
			</div>
		</template>
	</TutorialStep>
</template>

<script lang="ts" setup>
import AppNotification from "@/components/AppNotification.vue";
import TutorialStep from "@/components/TutorialStep.vue";
import router from "@/router";
import useQuestStore from "@/store/useQuestStore";
import { RouteNames, StatusTypes, TutorialStepTypes } from "@/types/ui";
import { storeToRefs } from "pinia";
import { computed } from "vue";

const questStore = useQuestStore();
const { tutorialActive, tutorialStep } = storeToRefs(questStore);

const showNotification = computed(
	// TODO: napojit
	(): boolean => true,
);

const openQuestMap = (): void => {
	if (tutorialActive.value) {
		questStore.addQuest(1, 0);
		questStore.setTutorialStep(8);
		router.push({
			name: RouteNames.QUESTS,
			params: {
				questPopupId: 1,
			},
		});
	} else {
		// eslint-disable-next-line no-console
		console.log("QuestBoxMap: openQuestMap");
	}
};
</script>

<style lang="scss" scoped>
.quest-box-map {
	position: relative;
	cursor: pointer;
	&__notification {
		position: absolute;
		top: -0.2rem;
		right: 0;
	}
}
</style>
